__turbopack_context__.v({
  "back": "chat-search-module-scss-module__pPRm0q__back",
  "dropdown": "chat-search-module-scss-module__pPRm0q__dropdown",
  "field": "chat-search-module-scss-module__pPRm0q__field",
  "icon": "chat-search-module-scss-module__pPRm0q__icon",
  "input": "chat-search-module-scss-module__pPRm0q__input",
  "item": "chat-search-module-scss-module__pPRm0q__item",
  "mark": "chat-search-module-scss-module__pPRm0q__mark",
  "mobileButton": "chat-search-module-scss-module__pPRm0q__mobileButton",
  "overlay": "chat-search-module-scss-module__pPRm0q__overlay",
  "overlayBar": "chat-search-module-scss-module__pPRm0q__overlayBar",
  "overlayList": "chat-search-module-scss-module__pPRm0q__overlayList",
  "section": "chat-search-module-scss-module__pPRm0q__section",
  "shortcut": "chat-search-module-scss-module__pPRm0q__shortcut",
  "snippet": "chat-search-module-scss-module__pPRm0q__snippet",
  "status": "chat-search-module-scss-module__pPRm0q__status",
  "title": "chat-search-module-scss-module__pPRm0q__title",
});
